/** OTP lifetime. Must match verification in `database/services/otp`. */
export const OTP_TTL_SECONDS = 5 * 60;
export const OTP_TTL_MS = OTP_TTL_SECONDS * 1000;

export enum USER_TYPES {
  ADMIN = "admin",
  ORGANIZER = "organizer",
  USER = "user",
  EXHIBITOR = "exhibitor",
  SPONSOR = "sponsor",
  VISITOR = "user",
  SPEAKER = "user",
  EXHIBITORS = "exhibitor",
  SPONSORS = "sponsor",
  VISITORS = "user",
  SPEAKERS = "user",
  MEDIA = "user",
  SUPPORT = "user",
  OTHER = "user",
}
